module.exports = __webpack_public_path__ + "static/media/Mitsubachi-61.56fb29c5.gif";